// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__uxy_q","xsmall":"Avatar_xsmall__aUSTT","small":"Avatar_small__RgAhW","medium":"Avatar_medium___OoyQ"};